// extracted by mini-css-extract-plugin
export var bubble = "_43-0";
export var container = "_43-f";
export var contrastBorder = "_43-g";
export var greyOut = "_43-2";
export var initialsColor0 = "_43-3";
export var initialsColor1 = "_43-4";
export var initialsColor10 = "_43-d";
export var initialsColor11 = "_43-e";
export var initialsColor2 = "_43-5";
export var initialsColor3 = "_43-6";
export var initialsColor4 = "_43-7";
export var initialsColor5 = "_43-8";
export var initialsColor6 = "_43-9";
export var initialsColor7 = "_43-a";
export var initialsColor8 = "_43-b";
export var initialsColor9 = "_43-c";
export var initialsWrapper = "_43-1";
export var large = "_43-l";
export var medium = "_43-k";
export var mediumSmall = "_43-j";
export var mediumSmallMedium = "_43-o";
export var micro = "_43-h";
export var small = "_43-i";
export var tiny = "_43-n";
export var xTiny = "_43-m";